export const vsServiceName = "partTransactionDetailComponentService";

export interface PartTransactionDetailComponentRegistration {
  tableName: string;
  componentName: string;
}

export class PartTransactionDetailComponentService {
  constructor(
    private readonly registrations: PartTransactionDetailComponentRegistration[]
  ) {}

  getPartDetailComponentRegistration(tableName: string) {
    return this.registrations.find((r) => r.tableName === tableName);
  }
}

export class PartTransactionDetailComponentController {}
